import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

export const BodyWeightSuggestion = ({ athleteIds, percentage, reference, testId }) => {
  const { api } = useAuth();
  const { language } = useLanguage();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const apiRef = useRef(api); apiRef.current = api;
  const valid = percentage !== '' && percentage != null && Number.isFinite(Number(percentage)) && Number(percentage) >= 0 && athleteIds?.length;
  const requestKey = JSON.stringify({ athlete_ids: athleteIds || [], pct_bw: valid ? Number(percentage) : null, ...reference });
  useEffect(() => {
    setResult(null); setError(false);
    if (!valid) return undefined;
    let active = true;
    const controller = new AbortController();
    const timer = setTimeout(() => apiRef.current.post('/prescriptions/resolve-bw-loads', JSON.parse(requestKey), { signal: controller.signal })
      .then(({ data }) => { if (active) setResult({ key: requestKey, data }); })
      .catch(e => { if (active && e.code !== 'ERR_CANCELED') setError(true); }), 200);
    return () => { active = false; clearTimeout(timer); controller.abort(); };
  }, [requestKey, valid]);
  if (!valid) return null;
  const current = result?.key === requestKey;
  return <div data-testid={testId} className="mt-2 space-y-1 min-w-0 border-t border-zinc-700 pt-2 text-xs" aria-busy={!current && !error}>
    <p className="text-zinc-400" data-testid={`${testId}-label`}>{language === 'IT' ? 'Carico esterno suggerito' : 'Suggested external load'}</p>
    {error ? <p role="alert" data-testid={`${testId}-error`}>{language === 'IT' ? 'Suggerimento non disponibile' : 'Suggestion unavailable'}</p>
      : !current ? <p role="status" data-testid={`${testId}-loading`}>…</p>
        : Object.entries(result.data).map(([aid, row]) => <div key={aid} className="flex flex-wrap gap-x-3 gap-y-1 [overflow-wrap:anywhere]" data-testid={`${testId}-${aid}`}>
          <span>{row.athlete_name}</span>
          <span className={row.load_kg == null ? 'text-amber-300' : 'text-emerald-400'} data-testid={`${testId}-${aid}-load`}>
            {row.load_kg == null ? (language === 'IT' ? 'Peso non disponibile' : 'Weight unavailable') : `${row.load_kg} kg`}
          </span>
          {row.has_weight && <span className="text-zinc-400" data-testid={`${testId}-${aid}-reference`}>BW {row.weight_kg} kg · {row.date} · {percentage}%</span>}
        </div>)}
  </div>;
};